import { SummitVerbose } from '@lc/card/verbose/SummitVerbose';
import {
	decisionCardResolution,
	decisionSummitWinter,
} from '@lc/const/turnTypes';
import { GameState } from '@lc/interface/gameState/types';
import { getPlayerStateWithId } from '@lc/lib/player_helper';
import { timeline_resolution } from '@lc/lib/timeline/resolution';

class TimelineResolutionWinter {
	async deleteOnTurnSummitCards(gameState: GameState, ticker: string[]) {
		for (const p of gameState.playerStateArray) {
			if (p.summitCards.length > 0) {
				for (let z = p.summitCards.length - 1; z >= 0; z--) {
					if (SummitVerbose[p.summitCards[z]].type === 'turn') {
						p.summitCards.splice(z, 1);
					}
				}
			}
		}
	}
	// How do I skip asking for summit cards? I guess after I ask player on
	// final turn of resolving contracts and awards (just last pass ask of player when they have no cards to resolve)
	// just delete their summit cards or use the "NO SUMMIT CARDS" boolean you'd use with flat earth contract
	determineCurrentActivePlayerWinter = (
		gameState: GameState,
		ticker: string[]
	) => {
		this.deleteOnTurnSummitCards(gameState, ticker);
		// players will have NO active contracts/awards OR summit cards after final pass
		for (const pId of gameState.currentTurnTypePlayerTableOrder) {
			console.log('Resolving turn order for player with id: ' + pId);
			const pState = getPlayerStateWithId(
				gameState.playerStateArray,
				pId
			);

			console.log('girth check');
			console.log(pState.activeContractsAndAwards.length);
			console.log(pState.summitCards.length);
			if (
				pState.activeContractsAndAwards.length > 0 ||
				pState.summitCards.length > 0
			) {
				ticker.unshift(
					`Player ${pId} is requested to make a summit decision`
				);
				gameState.turnType = decisionSummitWinter;
				gameState.activePlayerId = pId;
				return true;
			}
		}
		return false;
	};

	// for winter summit we pause before and after each card resolution for summit cards, along with pause for contract/award resolution
	// take next active contract/award off the stack and resolve it, send back decision request if necessary
	async resolveCurrentWinterContractOrAward(
		playerData: any,
		gameState: GameState,
		ticker: string[]
	) {
		console.log('resolveCurrentWinterContractOrAward');
		const activePlayerId = gameState.activePlayerId;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			activePlayerId
		);

		if (pState.activeContractsAndAwards.length === 0) {
			pState.summitCards = []; // player passes turn, skip em
		} else {
			const { pId, cId } = this.resolve(
				activePlayerId,
				pState.activeContractsAndAwards,
				gameState,
				ticker
			);
			if (pId !== -1 && cId !== -1) {
				ticker.unshift(
					`Player ${pId} completed Card Id ${cId} and is requested to make a decision`
				);
				gameState.turnType = decisionCardResolution;
				gameState.activePlayerId = pId;
				gameState.decisionCardId = cId;
				return true;
			}
		}
		return this.determineCurrentActivePlayerWinter(gameState, ticker);
	}

	resolve = (
		playerId: number,
		activeContractsAndAwards: number[],
		gameState: GameState,
		ticker: string[]
	) => {
		console.log('resolve WINTER SUMMIT');
		console.log(activeContractsAndAwards);

		return timeline_resolution.resolveAwardOrContractDecisionCheck(
			playerId,
			activeContractsAndAwards.length - 1,
			activeContractsAndAwards,
			gameState,
			ticker
		);
	};
}

export const timeline_resolution_winter = new TimelineResolutionWinter();
